import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { ChapterProgress } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { BookProgressActions } from '../book-progress/book-progress.actions';
import { mapChapterProgress } from './chapter-progress.functions';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const CHAPTER_PROGRESS_FEATURE_KEY: string = 'chapterProgress';

// eslint-disable-next-line
export interface ChapterProgressState extends EntityState<ChapterProgress> {}

export const chapterProgressAdapter: EntityAdapter<ChapterProgress> =
  createEntityAdapter<ChapterProgress>();

export const initialChapterProgressState: ChapterProgressState =
  chapterProgressAdapter.getInitialState({});

const reducer: ActionReducer<ChapterProgressState, Action> = createReducer(
  initialChapterProgressState,
  on(
    AuthActions.logoutSuccess,
    (): ChapterProgressState => initialChapterProgressState,
  ),
  on(
    BookProgressActions.getBookProgressSuccess,
    BookProgressActions.updateBookProgressSuccess,
    (state, action): ChapterProgressState =>
      chapterProgressAdapter.upsertMany(
        action.bookProgressResponse.chapterProgresses.map((chapterProgress) =>
          mapChapterProgress(chapterProgress),
        ),
        {
          ...state,
        },
      ),
  ),
);

export function chapterProgressReducer(
  state: ChapterProgressState | undefined,
  action: Action,
): ChapterProgressState {
  return reducer(state, action);
}
